/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Overrides_KeptInputs */

const en_field_overrides_kept = /** @type {(inputs: Field_Overrides_KeptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overrides kept`)
};

/**
* | output |
* | --- |
* | "Overrides kept" |
*
* @param {Field_Overrides_KeptInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const field_overrides_kept = /** @type {((inputs?: Field_Overrides_KeptInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Overrides_KeptInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_field_overrides_kept(inputs)
});